// extracted by mini-css-extract-plugin
export default {"canti":"Heromtavari_canti__O7mCL","first_place":"Heromtavari_first_place__iV5qm","main_page":"Heromtavari_main_page__y7Aaa","hh":"Heromtavari_hh__5V2P4"};